import { MainLogo } from "@software-engineering/hivolution-frontend-utils"
import { useAuth } from "oidc-react"
import { TieredMenu } from "primereact/tieredmenu"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router"

import menu from "@/utils/menu.js"

/**
 * Header component
 * @component
 * @returns {JSX.Element}
 */
export default function Header() {
  const { userData, signOutRedirect } = useAuth()
  const [menuItems, setMenuItems] = useState([])
  const user = useRef()
  const { t } = useTranslation()
  const [first] = menu("parameters").filter(entry => !entry.disabled && entry.visible)

  /**
   * Sign out user and redirect
   */
  const signOut = () => {
    signOutRedirect({ redirectMethod: "replace" })
  }

  /**
   * User information display component
   * @returns {JSX.Element}
   */
  const UserInfos = () => (
    <div>
      <span>{userData.profile.given_name}</span>
    </div>
  )

  useEffect(() => {
    userData &&
      setMenuItems([
        {
          className: "user-infos",
          template: UserInfos
        },
        {
          label: t("common.log_out"),
          icon: "fa-solid fa-power-off",
          command: () => signOut()
        }
      ])
  }, [userData])

  return (
    <header className="main-header">
      <nav
        className="navbar"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="home">
          <Link to="/">
            <i className="fa-solid fa-house" />
          </Link>
        </div>
        <Link to="/">
          <MainLogo />
        </Link>

        <div className="nav">
          {first && (
            <div className="parameters">
              <Link to={first.url}>
                <i className="fa-solid fa-gear" />
              </Link>
            </div>
          )}
          <div className="user">
            {userData && (
              <>
                <TieredMenu
                  popup
                  model={menuItems}
                  ref={user}
                  className="nav-menu"
                />

                <button onClick={e => user.current.toggle(e)}>
                  <i className="fa-solid fa-circle-user" />
                </button>
              </>
            )}
          </div>
        </div>
      </nav>
    </header>
  )
}
